import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'app-referrals',
    templateUrl: './referrals.component.html',
    styleUrls: [
        './../landing/landing.component.css',
        './referrals.component.css',
    ],
    standalone: false
})
export class ReferralsComponent implements OnInit {
  @ViewChild('pricing') pricing;
  isAccepted = false;
  endDate = null;
  email = '';
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    private notify: NotificationService
  ) {}
  referLink;
  ngOnInit(): void {
    this.loader.HideLoading();
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  async getReferralLink() {
    if (this.isAccepted) {
      const { data } = await this.userService
        .ReferPost({ endDate: this.endDate })
        .toPromise();
      this.referLink = data;
    }
  }
  copylink() {
    navigator.clipboard.writeText(this.referLink);
    this.notify.showInfo('Link Copied');
  }
  onClose() {
    this.modalService.dismissAll();
  }
  trustedDomains = ['@smbxl.com', '@familycentral.com', '@conceptdevgroup.com'];
  get isSMBLDomain() {
    return this.trustedDomains.some((i) =>
      this.userService.userInfo?.email?.toLowerCase()?.endsWith(i)
    );
  }
  async sendEmail(email) {
    if(this.email){
      await this.userService
      .ReferSend({ email: this.email, link: this.referLink })
      .toPromise();
    this.notify.showSuccess('Email sent');
    }else{
      email.control.markAllAsTouched();
    }
   
  }
}
